import { TSortValue } from '@components/table/types/SortValue.type';
import { getDefaultEnvironment } from '@utils/api-client';
import { Environment } from '@/config';
import { SetURLSearchParams } from 'react-router-dom';

export type SortQueryType = (sortOrder: string, prefix?: string) => string;

export type TableSortConfig = {
  sortQueryParam: Record<string, SortQueryType> | null;
  sortConfigPrefix?: {
    filterKey: string;
    sortKey: string;
    sortDirection: string;
  };
  defaultSort: TSortValue;

  /** custom callback handler for filter change */
  onSortChange?: () => void;
};

export const handleTableSortQueryParams = ({
  sortValues,
  sortConfig,
  sortConfigPrefixValue,
  syncToUrl,
  onSetQueryParams,
  searchParamsInTheUrl,
  onSetSearchParamsInTheUrl,
}: {
  sortValues: any;
  sortConfig: TableSortConfig;
  sortConfigPrefixValue?: string;
  syncToUrl?: boolean;
  onSetQueryParams: (callback: (prev: any) => any) => void;
  searchParamsInTheUrl: URLSearchParams;
  onSetSearchParamsInTheUrl: SetURLSearchParams;
}) => {
  // handle sort
  let prefixValue = undefined;
  if (sortConfig.sortConfigPrefix && !!sortConfigPrefixValue) {
    prefixValue = `${sortConfig.sortConfigPrefix?.sortKey}`;
  }

  if (!sortValues || !sortConfig?.sortQueryParam) {
    const queryValue = prefixValue
      ? sortConfig?.sortQueryParam?.[sortConfig.sortConfigPrefix?.sortKey as string]?.(
          sortConfig.sortConfigPrefix?.sortDirection ?? 'asc',
        )
      : undefined;

    onSetQueryParams((prev: any) => ({
      ...prev,
      sort: queryValue ? { queryKey: 'sort', queryValue } : undefined,
    }));
    if (syncToUrl) {
      if (queryValue) {
        searchParamsInTheUrl.set('sort', queryValue);
      } else {
        searchParamsInTheUrl.delete('sort');
      }
      onSetSearchParamsInTheUrl(searchParamsInTheUrl, { replace: true });
    }
    return;
  }

  if (syncToUrl) {
    searchParamsInTheUrl.set('sort', `${sortValues.field},${sortValues.sort}`);
    onSetSearchParamsInTheUrl(searchParamsInTheUrl, { replace: true });
  }

  const sortOrder = sortValues.sort === 'asc' ? '+' : '-';

  const queryValue = sortConfig?.sortQueryParam?.[sortValues.field]?.(sortOrder, prefixValue ? `-${prefixValue},` : '');

  if (!queryValue) {
    if (getDefaultEnvironment() !== Environment.Prod) {
      alert(`Sort for '${sortValues.field}' is not implemented - please log a bug`);
    } else {
      console.warn('Sort is not defined for: ', sortValues.field);
    }
    return;
  }

  onSetQueryParams((prev: any) => ({
    ...prev,
    sort: {
      queryKey: 'sort',
      queryValue,
    },
  }));
};
